import { render, staticRenderFns } from "./FuKanRules.vue?vue&type=template&id=5cb3e202&scoped=true&"
import script from "./FuKanRules.vue?vue&type=script&lang=ts&"
export * from "./FuKanRules.vue?vue&type=script&lang=ts&"
import style0 from "./FuKanRules.vue?vue&type=style&index=0&id=5cb3e202&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb3e202",
  null
  
)

export default component.exports